import styled from "styled-components";
import { breakpoints } from "styles";

export const TrialActivationWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TrialActivationTitle = styled.h2`
  color: ${({ theme }) => theme.colors.yellow[500]};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 40px;
  margin: 0;
  text-align: center;
`;

export const TrialActivationSubTitle = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  line-height: 24px;
  text-align: center;
  margin: 0;
`;

export const KelasLiveFeaturesHeading = styled.h2`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 48px;
  text-align: center;
  color: ${({ theme }) => theme.colors.yellow[500]};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  line-height: 30px;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }

  &:before {
    content: "";
    background: url("/assets/kelas-live/stars.svg") no-repeat;
    display: block;
    width: 40px;
    height: 40px;
    position: relative;
    right: 8px;
    bottom: 6px;
  }
  &:after {
    content: "";
    background: url("/assets/kelas-live/stars.svg") no-repeat;
    display: block;
    width: 40px;
    height: 40px;
    position: relative;
    left: 8px;
    bottom: 6px;
    transform: scaleX(-1);
  }
  margin-bottom: 0;
`;

export const KelasLiveFeaturesContainer = styled.div`
  margin-bottom: 10px;
`;

export const KelasLiveFeatures = styled.div`
  color: ${({ theme }) => theme.colors.white};
  margin: 12px;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: start;
  align-items: start;
  @media ${breakpoints.laptop} {
    margin: 20px;
  }
`;

export const KelasLiveFeaturesImage = styled.div`
  grid-row: 1 / 3;
  margin-right: 15px;
`;

export const KelasLiveFeaturesTitle = styled.h4`
  font-weight: bold;
  line-height: 20px;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
    line-height: 30px;
  }
`;

export const KelasLiveFeaturesDesc = styled.p`
  font-weight: normal;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes["xs"]};
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["sm"]};
  }
`;

export const TrialActivationStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TrialActivationStatusImage = styled.figure`
  margin: 0;
`;

export const TrialActivationStatusTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  font-weight: bold;
  text-align: center;
  line-height: 40px;
  margin: 0;
`;

export const TrialActivationStatusDesc = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
`;
